<script setup>
const props = defineProps(['helpObject']) // whether it is a level or intracavitary chris
const emits = defineEmits(['close'])
function dontClose(event) {
    event.stopPropagation();
}
</script>
<template>
    <div class="modal" @click="emits('close')">
        <div class="modal-content" @click="dontClose">
            <div class="container">
                <h1>{{ props.helpObject.name }}</h1>
                <p v-for="(rule) in props.helpObject.rules">{{ rule }}</p>
            </div>

        </div>
    </div>
</template>
<style scoped lang="scss">
</style>